<template>
  <div v-loading="loadingUse">
    <div class="divButtonRigth">
        <el-button type="primary" size="small" @click="_exportTableDetail">账单下载</el-button>
        <el-button type="primary" size="small" v-if="currentTab==='exe'" @click="_batchAgentConfirm">账单确认</el-button>
    </div>
    <bsp-table ref="accountTable"
               :data.sync="list" :ciic-data-filter.sync="listQuery"
               @select-change="selectChange" @select-all="selectAll" @ciic-data-refresh="_getListpage"
               show-header-overflow show-overflowwidth

               show-overflow
               v-loading="loading"
               element-loading-text="拼命加载中"
               element-loading-spinner="el-icon-loading"
               show-footer-overflow
               show-footer :footer-method="footerMethod" :showPagination="listQuery.page"
               fixed="left">
      <vxe-table-column type="selection" width="50" fixed="left"/>
      <bsp-table-column title="操作" width="250px" fixed="right" align="center">
        <template slot-scope="scope">
          <div class="ciic-table-operate">
            <el-button type="text" @click="showPayOrder(scope.row)" v-if="currentTab==='exe' && !scope.row.chargeUp">
              {{scope.row.templateId == null || scope.row.templateId == '' ? '上传通知单' : '已传通知单'}}
            </el-button>
            <el-button type="text" @click="showImpDetail(scope.row)">明细数据 </el-button>
            <el-button type="text" @click="_useBalance(scope.row)" v-if="scope.row.status==30680003&&scope.row.invoiceNum==0">使用余额</el-button>
          </div>
        </template>
      </bsp-table-column>

      <bsp-table-column field="pay.id" title="账单编号" width="150px" align="center" fixed="left"
                        :slot-filter="false" filter-type="input" >
        <template slot-scope="scope"><span>{{ scope.row.id }}</span></template>
      </bsp-table-column>

      <bsp-table-column field="pay.contractCode" title="合同编号" width="150px" align="center" fixed="left"
                        :slot-filter="false" filter-type="input" >
        <template slot-scope="scope"><span>{{ scope.row.contractCode }}</span></template>
      </bsp-table-column>
<!--      <bsp-table-column field="cusNum" title="客户编号" width="130px" align="center" fixed="left"-->
<!--                        :slot-filter="true" sortable filter-type="input">-->
<!--        <template slot-scope="scope"><span>{{ scope.row.cusNum }}</span></template>-->
<!--      </bsp-table-column>-->
      <bsp-table-column field="cusName" title="客户名称" width="250px" align="center" fixed="left"
                        :slot-filter="true" sortable filter-type="input">
        <template slot-scope="scope"><span>{{ scope.row.cusName }}</span></template>
      </bsp-table-column>

      <bsp-table-column field="needPay" title="应付总额" width="120px" align="center">
        <template slot-scope="scope"><span>{{ scope.row.needPay |moneyFilter }}</span></template>
      </bsp-table-column>

      <bsp-table-column field="factPay"  title="实付总额"  width="120px" align="center">
        <template slot-scope="scope"><span>{{ scope.row.factPay |moneyFilter}}</span></template>
      </bsp-table-column>

      <bsp-table-column   v-if="wayList.length>0" field="billConfirmWay" title="账单确认方式"
                          filter-rule="in" filter-type="select"  align="center" width="150px"
                          :optionProps="{value:'codeItemId',label:'codeItemName'}" :optionsList="wayList">
        <template slot-scope="scope">
          <span>{{ scope.row.billConfirmWay | dictFilter(dicts) }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column v-if="confirmStatusList.length>0" field="confirmStatus" title="确认状态"
                        filter-rule="in" filter-type="select"  align="center" width="100px"
                        :optionProps="{value:'codeItemId',label:'codeItemName'}" :optionsList="confirmStatusList">
        <template slot-scope="scope">
          <span>{{ scope.row.confirmStatus | dictFilter(dicts) }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column field="isOtherBiz" title="是否其他业务收费生成" width="200px" align="center">
        <template slot-scope="scope"><span>{{ scope.row.isOtherBiz|dictFilter(dicts) }}</span></template>
      </bsp-table-column>

      <bsp-table-column field="markStatus" title="锁定状态" width="200px" align="center">
        <template slot-scope="scope"><span>{{ scope.row.markStatus|dictListFilter(markStatusList) }}</span></template>
      </bsp-table-column>

      <bsp-table-column v-if="flowList.length>0" field="status" title="流程状态"
                        filter-rule="in" filter-type="select" width="100px" align="center"
                        :optionProps="{value:'codeItemId',label:'codeItemName'}" :optionsList="flowList">
        <template slot-scope="scope"><span>{{ scope.row.status | dictFilter(dicts)  }}</span></template>
      </bsp-table-column>

      <bsp-table-column field="useBalance" title="财务余额" width="100px" align="center">
        <template slot-scope="scope"><span>{{ scope.row.useBalance |moneyFilter }}</span></template>
      </bsp-table-column>

      <bsp-table-column field="usePubBalance" title="对公余额" width="100px" align="center">
        <template slot-scope="scope"><span>{{ scope.row.usePubBalance | moneyFilter}}</span></template>
      </bsp-table-column>
    </bsp-table>


    <el-dialog v-dialogDrag
      ref="useBalance"
      width="740px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="使用余额"
      :visible.sync="dialogBalanceVisible"
      @data-refresh="_getListpage"
    >
      <use-balance  :balance-info="balanceInfo" :balance-lists="balanceLists" :balance-lists-copy="balanceListsCopy" :balance-lists-copy2="balanceListsCopy2" :ky-balance-list="kyBalanceList"
                    @closeDialog="closeBalanceDialog">
      </use-balance>
    </el-dialog>

    <el-dialog v-dialogDrag
      ref="payOrder"
      width="740px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="付款通知单上传"
      :visible.sync="dialogPayOrderVisible"
      @data-refresh="_getListpage"
    >
      <pay-order :balance-info="balanceInfo" :click-row="payOrderRow" @payOrderDialog="payOrderDialog"></pay-order>
    </el-dialog>

    <!-- <el-dialog v-dialogDrag
      ref="contractTable"
      width="740px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="exportOrMail == 'mail' ? '选择合同发送邮件' : '选择合同进行导出'"
      :visible.sync="dialogContractTableVisible"
      @data-refresh="_getListpage"
    >
      <contract-table :exportOrMail="exportOrMail" :balance-info="balanceInfo" :contractLists="contractLists"
      :click-row="payOrderRow" @contractTableDialog="contractTableDialog"
      ></contract-table>
    </el-dialog> -->

    <split-invoice-dialog
      ref="splitInvoice"
      :dialog-invoice-visible.sync="dialogInvoiceVisible"
      :notice-id.sync="noticeId"
      :cus-id.sync="cusId"
      @data-refresh="_getListpage"
      @closeDialog="closeInvoiceDialog"
    >
    </split-invoice-dialog>

  </div>
</template>

<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import bspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
  import useBalance from "./useBalance";
  import payOrder from "./payOrder";
  import contractTable from "./contractTable";
  import splitInvoiceDialog from "./splitInvoice";

  import {getCodeItems,getListpage,batchDeleteNotice,batchAgentConfirm,createNotice,createInvoice,getBizItemList,saveUseBalance,strikeBalance} from "@/api/biz/bill/pay-notice"
  import {getDicts,getDictsListBySetId} from '@/api/sys/code'
  import {mapGetters} from 'vuex';
  import { getXcInfoExcel } from "@/api/biz/salaryBatchInfo"
  import { downloadFile } from '@/util/util';
  import exportMethod from "@/util/export";
  import { getbargaincodebycusid } from "@/api/orig-biz/orig-biz";
  // import { downloadFile } from '@/util/util';

  export default {
    name: "pay-notice-list",
    components: {bspTableColumn, bspTable,useBalance,splitInvoiceDialog,payOrder,contractTable},
    props: {
      currentTab: {
        type: String,
        default: 'exe'
      },
    },
    created() {
      this.getCodeItemList();
      // this._getListpage();
    },

    computed: {
      ...mapGetters(['dicts']),
    },
    filters: {

    },
    watch: {
      currentTab: {
        handler(newName, oldName) {
            this.listQuery.flag = newName;
            this._getListpage();
        },
        immediate: true,
      }
    },
    data() {
      return {
        contractLists: [], //合同信息
        payOrderRow: {}, //付款通知单信息
        wayList: [],
        flowList: [],
        confirmStatusList: [],
        multipleSelection: [],
        list:[],
        listQuery: {
          limit: 50,
          page: 1,
          total: 0,
          flag:'exe',
          isSort:true,// 是否加序号列
          dataList:[],// 页面勾选的数据用来作导出
          type:'excel',// 类型
          fileName:'账单信息.xls',// 导出的文件名
          beanName:'payNoticeServiceImpl',// 指定调用的那个service
          methodName:'queryListPageQuery',// 指定调用的那个savercie 那个方法
          translates:[
            {field:'billConfirmWay',type:'code',param:'3035'},
            {field:'status',type:'code',param:'3068'},
            {field:'confirmStatus',type:'code',param:'3044'}
          ],//要翻译的字段 field：字段  type：类型 code,cusRef,... ,param:参数 如果有多 cusId=1,cusId1=2
        },
        //使用余额
        balanceLists:[],
        balanceListsCopy:[],
        balanceListsCopy2:[],
        dialogBalanceVisible: false,
        dialogPayOrderVisible: false,
        dialogContractTableVisible: false,
        balanceInfo:
          {
            id:null,
            month:this.todayDate(),
            cusName:null,
            totalNeedPay: null,
            totalFactPay:null,
            totalUseBalance:null,
            totalUsePubBalance:null,
            useBalanceList:null,
          },
        markStatusList:[
          {codeItemId: '-1',codeItemName:'未锁定'},
          {codeItemId: '0',codeItemName:'待锁定'},
          {codeItemId: '1',codeItemName:'锁定'},
          {codeItemId: '2',codeItemName:'冲账待审批'},
          {codeItemId: '3',codeItemName:'冲账已审批'},
        ],
        kyBalanceList:[],
        //发票拆分
        dialogInvoiceVisible:false,
        noticeId:null,
        cusId:null,
        loadingUse:false
      }
    },
    methods: {
      // 关闭使用余额
      closeBalanceDialog(){
        this.dialogBalanceVisible = false;
        this._getListpage();
      },
      closeInvoiceDialog(){
        this.dialogInvoiceVisible = false;
        this._getListpage();
      },

      // 复选框单选事件
      selectChange({checked, row}) {
        if (checked) {
          this.multipleSelection.push(row.id)
        }
        if (!checked) {
          this.multipleSelection.filter((item, index) => {
            if (item === row.id) {
              this.multipleSelection.splice(index, 1)
            }
          })
        }
      },
      //复选框全选事件
      selectAll({checked, selection}) {
        if(checked){
          var i=0;
          this.multipleSelection=[];
          for(i;i<selection.length;i++){
            this.multipleSelection.push(selection[i].id);
          }
        }else{
          this.multipleSelection=[];
        }
      },
      todayDate(){
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month ;//+ seperator1 + strDate;

        return currentdate;
      },
      // 导出付款通知单
      _exportTableDetail() {
        if (this.multipleSelection.length == 1) {
          let nowInfo = this.list.filter(item => item.id == this.multipleSelection[0])[0];
          console.log("nowInfo", nowInfo);
          if (nowInfo.chargeUp) {
            this.$message.info("已充账，无法导出！");
            return;
          }
          // if (!nowInfo.noticeCode == null) {
          //   this.$message.info("没有合同编号！，无法导出！");
          //   return;
          // }
          let param = {
            id: this.multipleSelection[0],
            isOtherBiz: nowInfo.isOtherBiz=='10020001' ? true : false,
            contractCode: nowInfo.contractCode ? nowInfo.contractCode : '',
            contractType: nowInfo.specificServItems ? nowInfo.specificServItems : '',
          }
          if ('xxxxxxxxx=',nowInfo.templateId) {
            getXcInfoExcel(param).then(res => {
              downloadFile(res)
              this.$message.success("付款通知单导出成功！");
            })
          } else {
            getXcInfoExcel(param).then(res => {
              downloadFile(res)
              this.$message.success("付款通知单导出成功！");
            })
          }
        } else {
          if (this.multipleSelection.length == 0) {
            this.$message.info("请选择一个付款通知单导出");
          } else {
            this.$message.info("只能选择导出一个付款通知单");
          }
        }
      },
      //下载账单
      _exportTable(){
        if(this.multipleSelection.length>0){
          // this.listQuery.dataList= this.selectRow;
          for(var i=0;i<this.multipleSelection.length;i++) {
            const found = this.list.find(element => element.id ==this.multipleSelection[i]);
            this.listQuery.dataList[i]=found;
          }
        }else{
          this.listQuery.dataList=[];
        }
        exportMethod({columns: this.$refs['accountTable'].tableColums, ...this.listQuery}, '/biz',false);
      },
      //获取列表数据
      _getListpage() {
        getListpage(this.listQuery).then(res => {
          this.listQuery.total = res.data.total
          this.list = res.data.records
          this.multipleSelection=[];
        })
      },
      getCodeItemList() {
        this.wayList=[{codeItemId: "30350001",codeItemName: "手动确认"},{codeItemId: "30350002",codeItemName: "自动确认"}];
        this.confirmStatusList=[{codeItemId: "30440001",codeItemName: "待确认"},{codeItemId: "30440002",codeItemName: "已确认"}];
        this.flowList=[{codeItemId: "30680002",codeItemName: "待生成账单"},{codeItemId: "30680003",codeItemName: "待生成发票"},{codeItemId: "30680004",codeItemName: "待认单"},{codeItemId: "30680005",codeItemName: "待销账"},{codeItemId: "30680006",codeItemName: "已销账"}]
      },
      _batchAgentConfirm(){
        if(this.multipleSelection.length<1) {
          this.$message.warning("请选择账单！")
          return ;
        }
        batchAgentConfirm(this.multipleSelection).then(res => {
          if(res.data.code==0) {
            this.$message.success("确认成功");
            this._getListpage();
          }
        })
      },

      showImpDetail(row){
        if(row.isOtherBiz=='10020001'){ //如果是其他业务收费创建就直接跳转到其他业务收费明细页面
          this.$router.push({
            path: '/biz/other-biz/detail-list',
            query: {
              batchId: row.id
            }
          })
        }else{
                  this.$router.push({
          path: '/wage/payment/pay-notice/emp-wage-detail',
          query:{
            noticeId:row.id,
            // templateId:row.salaryTemplateId
            viewType:"bill",
          }
        })
        }

      },
      // 打开付款通知单
      showPayOrder(row) {
        this.payOrderRow = row;
        this.dialogPayOrderVisible = true;
      },
      // 附件上传完成回调关闭弹窗
      payOrderDialog(value) {
        console.log(value);
        this.dialogPayOrderVisible = false;
        this.list = this.list.map(item => {
          if (item.id == value.id) {
            item.templateId = value.templateId;
          }
          return item;
        })
      },
         _useBalance(row){
              this.loadingUse = true;
              this.balanceInfo.id=row.id;
              this.balanceInfo.cusName=row.cusName;
              this.balanceInfo.totalUseBalance=row.useBalance;
              this.balanceInfo.totalUsePubBalance=row.usePubBalance;
              this.balanceInfo.totalNeedPay=row.needPay;
              this.balanceInfo.totalFactPay=row.factPay;
              var id=row.id;
              getBizItemList(id).then(res => {
                // this.balanceLists=res.data;
                this.balanceLists=res.data.data.bizItemList;
                // 为了保证计算可回退，保存一份实付和抵扣的数据,加载或更新完数据复制一份,为了使展开行和总数据分离，再复制一份
                this.balanceListsCopy = JSON.parse(JSON.stringify(this.balanceLists))
                this.balanceListsCopy2 = JSON.parse(JSON.stringify(this.balanceLists))
                this.kyBalanceList=res.data.data.balance;
                this.dialogBalanceVisible = true;
                this.loadingUse = false;
              })
            },


            _createAdvance(){
              if(this.multipleSelection.length==0){
                this.$message.info("请选择账单");
                return ;
              }else if(this.multipleSelection.length>1){
                this.$message.info("只能选择一个账单");
                return ;
              }

              let row=null;
              for(let i=0;i<this.list.length;i++){
                let item=this.list[i];
                if(item.id==this.multipleSelection[0]){
                  if(item.status==="30680005"||item.status==="30680006"){
                    this.$message.error("账单已认单不能申请垫付！");
                    return;
                  }else if(item.advanceNum>0){
                    this.$message.error("账单已申请垫付，不能重复申请！");
                    return;
                  }else {
                    row=item;
                    break;
                  }
                }
              }
              if(row!=null){
                this.$router.push({
                  path: '/biz/advance/add',
                  query:{
                    noticeId:row.id,
                  }
                })
              }
            },
      // 合计
      footerMethod({columns, data}) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计'
            }
            if (['needPay','factPay','useBalance','usePubBalance'].includes(column.property)) {
              return this.$options.filters['moneyFilter'](this.$utils.sum(data, column.property))
            }
            return null
          })
        ]
      },
    }
  }
</script>

<style scoped>

</style>
